import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { RouterState } from './routing';

import * as fromAuth from './auth/reducers';
import * as fromAuthActions from './auth/actions/auth.actions';
import * as fromLocalAuthorities from './local-authorities/reducers';

export interface AppState {
    [fromAuth.authFeatureKey]: fromAuth.AuthState;
    router: RouterState;
    localAuthorities: fromLocalAuthorities.LocalAuthoritiesState;
}

export const reducers: ActionReducerMap<AppState> = {
    [fromAuth.authFeatureKey]: fromAuth.reducer,
    router: routerReducer,
    localAuthorities: fromLocalAuthorities.reducer
};

export function localStorageSyncReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
    return localStorageSync({
        keys: [fromAuth.authFeatureKey],
        rehydrate: true,
        storageKeySerializer: (key) => `vimo_${key}`
    })(reducer);
}

export function logoutClearState(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
    return function (state, action) {
        if (action.type === fromAuthActions.LOGOUT) {
            state = undefined;
        }
        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<AppState>[] = [localStorageSyncReducer, logoutClearState];
